// eslint-disable-next-line no-unused-vars
import React, { useContext } from 'react';
import { ViewContext } from '../context/ViewContext';
import { EnquiryContext } from '../context/EnquiryContext';
import inboxService from 'venuescanner-js/services/inbox';
import {
  inboxStatus,
  inboxStatusThreadStatus,
  fetchInboxSortBy,
} from 'venuescanner-js/constants/thread';
import { setServiceMethods } from '../services/inboxService';
import mongoId from 'venuescanner-js/validation/mongoId';
// import Emitter, { eventNames } from './eventEmitter'
const { status: leadStatus } = require('venuescanner-js/constants/leads');
const getInboxStatusFromStatus = status => {
  return Object.keys(inboxStatusThreadStatus).find(key =>
    inboxStatusThreadStatus[key].includes(status),
  );
};

const getThreadIdFromPath = () => {
  if (typeof window !== 'undefined') {
    const params = window.location.pathname.replace(/^\//, '').split('/');
    const threadId =
      params[0] === 'inbox' && params.length > 1 ? params[1] : null;
    if (threadId && mongoId(threadId)) return threadId;
  }
  return null;
};
const updateLeadContexts = () => {
  // console.log('updateLeadContexts')
  const leads = contextContainer.allLeads;
  const organiserLeads = leads.filter(l => l._subjects._value.isOrganiser);
  const adminEvents = Object.values(
    organiserLeads.reduce((acc, lead) => {
      const eventId = lead._subjects._value.admin_event._id;
      if (!acc[eventId])
        acc[eventId] = { ...lead._subjects._value.admin_event };
      if (!acc[eventId].leads) acc[eventId].leads = [];
      acc[eventId].leads.push(lead);
      return acc;
    }, {}),
  ).sort((a, b) => {
    return b.date_from - b.date_from;
  });
  // console.log(adminEvents)
  // console.log(organiserLeads)
  contextContainer.setOrganiserLeads(adminEvents);
  const hostLeads = leads.filter(l => !l._subjects._value.isOrganiser);
  // contextContainer.setHostLeads(hostLeads)
  contextContainer.setHostLeads(
    hostLeads.filter(l =>
      [leadStatus.OPEN, leadStatus.INTERESTED].includes(
        l._subjects._value.lead.status,
      ),
    ),
  );
  const missed = hostLeads.filter(l =>
    [leadStatus.STALE, leadStatus.EXPIRED].includes(
      l._subjects._value.lead.status,
    ),
  );
  contextContainer.setMissedLeads(missed);
  contextContainer.setLeadCounts({
    leads: hostLeads.filter(
      l => leadStatus.OPEN === l._subjects._value.lead.status,
    ).length,
    matches: organiserLeads.filter(
      l => leadStatus.INTERESTED === l._subjects._value.lead.status,
    ).length,
  });
  // Emitter.emit(eventNames.STATUS_CHANGE)
};
const contextContainer = {};
const limit = 50;
const filter = () => {
  const filter = { limit, sort: fetchInboxSortBy.LAST_ACTION_DATE };

  if (contextContainer.statusFilter) {
    filter.status = contextContainer.statusFilter;
  }

  if (!filter.status || !filter.status.length) {
    filter.status = [
      inboxStatus.NEW,
      inboxStatus.OPEN,
      inboxStatus.CLOSED,
      inboxStatus.BOOKED,
    ];
  }

  if (contextContainer.searchFilter) {
    filter.search = contextContainer.searchFilter;
  }

  if (contextContainer.sortOrder) {
    filter.sort = contextContainer.sortOrder;
  }

  return filter;
};
export const Emitter = inboxService.Emitter;
export const start = () => {
  // socket service methods
  const middleware = {
    /** @function
     * @async
     * @name loadThread
     * @ignore
     * @desc Fetches an instance of a Thread model and associated models, then set the active thread and the active view in the Context
     * @param _id {string} The _id of the thread to fetch
     */
    loadThread: async _id => {
      contextContainer.setThreadLoading(true);
      const { thread } = await inboxService.thread.fetch(_id);
      // console.log('post', thread)
      contextContainer.setActiveThread(thread);
      contextContainer.setThreadLoading(false);
      return thread;
    },

    /** @function
     * @async
     * @name fetchThread
     * @ignore
     * @desc Fetches an instance of a Thread model and associated models
     * @param _id {string} The _id of the thread to fetch
     */
    fetchThread: async _id => {
      const { thread } = await inboxService.thread.fetch(_id);
      return thread;
    },

    /** @function
     * @async
     * @name replyThread
     * @ignore
     * @desc Reply to a thread
     * @param {Object} options
     * @param {String} options._id - The _id of the thread
     * @param {String} options.message - The message to reply with
     * @param {String[]} options.attachments - Any attachments to include in the response
     */
    replyThread: async ({ _id, message, attachments }) => {
      const { thread } = await inboxService.thread.reply({
        _id,
        message,
        attachments,
      });
      return thread;
      // console.log('replyThread', thread)
    },
    /** @function
     * @async
     * @name updateThread
     * @ignore
     * @desc Update to a thread
     * @param {Object} options
     * @param {String} options._id - The _id of the thread
     * @param {String} options.message - The message to reply with
     * @param {String[]} options.attachments - Any attachments to include in the response
     * @param {Object} options.quote - Ammended offer details
     * @param {Object} options.schedule - Deposit schedule for future payments
     */
    updateThread: async ({
      _id,
      offer,
      message,
      attachments,
      payment,
      schedule,
    }) => {
      return inboxService.thread.update({
        _id,
        offer,
        message,
        attachments,
        payment,
        schedule,
      });
    },
    trackContactDetailsReveal: async ({ _id, field }) => {
      return inboxService.thread.trackContactDetailsReveal({ _id, field });
    },
    /** @function
     * @async
     * @name acceptThread
     * @ignore
     * @desc Reply & accept a thread
     * @param {Object} options
     * @param {String} options._id - The _id of the thread
     * @param {String} options.message - The message to reply with
     * @param {String[]} options.attachments - Any attachments to include in the response
     * @param {Object} options.offer - Accepted offer details as a diff
     * @param {Object} options.payment - Payment amount for initial deposit
     * @param {Object} options.schedule - Deposit schedule for future payments
     */
    acceptThread: async ({
      _id,
      offer,
      message,
      attachments,
      payment,
      schedule,
    }) => {
      return inboxService.thread.accept({
        _id,
        offer,
        message,
        attachments,
        payment,
        schedule,
      });
    },

    /** @function
     * @async
     * @name cancelThread
     * @ignore
     * @desc Cancel a thread
     * @param {Object} options
     * @param {String} options._id - The _id of the thread
     * @param {String} options.message - The message to reply with
     * @param {String[]} options.attachments - Any attachments to include in the response
     * @param {Object} options.offer - Accepted offer details as a diff
     * @param {String} options.reason - Reason for cancellation
     */
    cancelThread: async ({ _id, offer, message, attachments, reason }) => {
      return inboxService.thread.cancel({
        _id,
        offer,
        message,
        attachments,
        reason,
      });
    },

    /** @function
     * @async
     * @name declineThread
     * @ignore
     * @desc Decline a thread
     * @param {Object} options
     * @param {String} options._id - The _id of the thread
     * @param {String} options.message - The message to reply with
     * @param {String[]} options.attachments - Any attachments to include in the response
     * @param {Object} options.offer - Accepted offer details as a diff
     * @param {String} options.reason - Reason for cancellation
     */
    declineThread: async ({ _id, offer, message, attachments, reason }) => {
      return inboxService.thread.decline({
        _id,
        offer,
        message,
        attachments,
        reason,
      });
    },

    /** @function
     * @async
     * @name reopenThread
     * @ignore
     * @desc Update to a thread
     * @param {Object} options
     * @param {String} options._id - The _id of the thread
     * @param {String} options.message - The message to reply with
     * @param {String[]} options.attachments - Any attachments to include in the response
     * @param {Object} options.quote - Ammended offer details
     */
    reopenThread: async ({ _id, offer, message, attachments }) => {
      // console.log({ _id, offer, message, attachments })
      return inboxService.thread.reopen({ _id, offer, message, attachments });
    },

    /** @function
     * @async
     * @name bookThread
     * @ignore
     * @desc Book a thread
     * @param {Object} options
     * @param {String} options._id - The _id of the thread
     * @param {String} options.message - The message to reply with
     */
    bookThread: async ({ _id, message, attachments }) => {
      return inboxService.thread.book({ _id, message, attachments });
    },

    /** @function
     * @async
     * @name requestPayment
     * @ignore
     * @desc Request a payment for a booked thread
     * @param {Object} options
     * @param {String} options._id - The _id of the thread
     * @param {String} options.message - The message to reply with
     * @param {String} options.payment - The value of the payment request
     */
    requestPayment: async ({ _id, message, payment, attachments }) => {
      return inboxService.thread.requestPayment({
        _id,
        message,
        payment,
        attachments,
      });
    },

    /** @function
     * @async
     * @name markBookedThread
     * @ignore
     * @desc Mark as Booked a thread
     * @param {Object} options
     * @param {String} options._id - The _id of the thread
     * @param {String} options.message - The message to reply with
     */
    markBookedThread: async ({ _id, message, attachments }) => {
      return inboxService.thread.markAsBooked({ _id, message, attachments });
    },

    /** @function
     * @async
     * @name unmarkBookedThread
     * @ignore
     * @desc Unmark as Booked a thread
     * @param {Object} options
     * @param {String} options._id - The _id of the thread
     */
    unmarkBookedThread: async ({ _id, message, attachments }) => {
      return inboxService.thread.unmarkAsBooked({ _id, message, attachments });
    },

    /** @function
     * @async
     * @name markClosedThread
     * @ignore
     * @desc Mark as Closed a thread
     * @param {Object} options
     * @param {String} options._id - The _id of the thread
     * @param {String} options.message - The message to reply with
     */
    markClosedThread: async ({ _id, message, attachments }) => {
      return inboxService.thread.markAsClosed({ _id, message, attachments });
    },

    /** @function
     * @async
     * @name showToOrganiser
     * @ignore
     * @desc Let the Organiser see this thread - for Concierge managed only
     * @param {Object} options
     * @param {String} options._id - The _id of the thread
     */
    showToOrganiser: async ({ _id }) => {
      return inboxService.thread.showToOrganiser({ _id });
    },

    /** @function
     * @async
     * @name nudgeHost
     * @ignore
     * @desc Let the Organiser nudge the host that they are interested in booking
     * @param {Object} options
     * @param {String} options._id - The _id of the thread
     */
    nudgeHost: async ({ _id, message, attachments }) => {
      return inboxService.thread.nudgeHost({ _id, message, attachments });
    },

    /** @function
     * @async
     * @name leads
     * @ignore
     * @desc Fetches Leads preview models, using the filter and venue ids recorded inthe context. The returning list of models is then assigned to the threads of the context. Note: A new thread that has been pushed and not requested is automatically prepended to the threads list in the context.
     */

    leads: async () => {
      // throw new Error('calling threads')
      // contextContainer.setEnquiriesLoading(true)
      inboxService.leads.onNew(leads => {
        leads.forEach(l => l.observable().subscribe(updateLeadContexts));
        contextContainer.setAllLeads([...contextContainer.allLeads, ...leads]);
        updateLeadContexts();
      });
      const { lead } = await inboxService.leads.fetch();
      lead.forEach(l => l.observable().subscribe(updateLeadContexts));
      contextContainer.setAllLeads(lead);
      updateLeadContexts();
    },
    /** @function
     * @async
     * @name leadIgnore
     * @ignore
     * @desc Let's the Organiser or Host Ignore the Lead
     * @param {Object} options
     * @param {String} options._id - The _id of the lead
     * @param {String} options.message - A message to apply to this ignore lead
     * @param {String} options.reason - The reason for ignoring this lead
     */

    leadIgnore: async ({ _id, message, reason }) => {
      // throw new Error('calling threads')
      // contextContainer.setEnquiriesLoading(true)
      return inboxService.leads.ignore({ _id, message, reason });
    },
    /** @function
     * @async
     * @name leadAccept
     * @ignore
     * @desc Let's the Organiser Accept the Lead and create an Enquiry from it
     * @param {Object} options
     * @param {String} options._id - The _id of the lead
     */

    leadAccept: async ({ _id, message }) => {
      // throw new Error('calling threads')
      // contextContainer.setEnquiriesLoading(true)
      return inboxService.leads.accept({ _id, message });
    },
    /** @function
     * @async
     * @name leadInterested
     * @ignore
     * @desc Let's the Host Accept the Lead, which let's the Organiser accept it
     * @param {Object} options
     * @param {String} options._id - The _id of the lead
     * @param {String} options.price - The Price update for a Lead
     * @param {String} options.message - Message to the Organiser
     * @param {String} options.space - SpaceId - leave null to not change
     */

    leadInterested: async ({ _id, price, message, space }) => {
      return inboxService.leads.interested({ _id, price, message, space });
    },

    /** @function
     * @async
     * @name leadsRead
     * @ignore
     * @desc Marks the list of Leads as read by the viewer
     * @param {Array} ids = Array of Lead Ids
     */
    leadsRead: async ids => {
      return inboxService.leads.read({ _id: ids });
    },

    /** @function
     * @async
     * @name threads
     * @ignore
     * @desc Fetches thread preview models, using the filter and venue ids recorded inthe context. The returning list of models is then assigned to the threads of the context. Note: A new thread that has been pushed and not requested is automatically prepended to the threads list in the context.
     */

    threads: async ({ ensureThread } = {}) => {
      contextContainer.setEnquiriesLoading(true);
      contextContainer.setThreads([]);
      const { threads, counts } = await inboxService.threads.fetch({
        filter: filter(),
        ensureThread,
      });

      contextContainer.setThreads(threads);

      if (threads.length) {
        const { thread } = await inboxService.thread.fetch(
          ensureThread ? ensureThread : threads[0].toJSON()._id,
        );

        if (thread) {
          contextContainer.setActiveThread(thread);
        }
      }

      if (counts) {
        contextContainer.setCounts(counts);
      }

      contextContainer.setEnquiriesLoading(false);
      setTimeout(() => {
        contextContainer.setEnquiriesAvailable(threads.length >= limit);
      });
    },
    /** @function
     * @async
     * @name indicators
     * @ignore
     * @desc Fetches indicators according to the user.
     * @returns {Object} indicators
     */
    indicators: async () => {
      const { indicators } = await inboxService.counts.indicators();
      contextContainer.setIndicators(indicators);
    },
    /** @function
     * @async
     * @name counts
     * @ignore
     * @desc Fetches and sets the totals, unreads, past or future counts for each inbox status, then applies this to the context.
     */
    counts: async () => {
      const { counts } = await inboxService.counts.all({
        // venueIds: contextContainer.venues.map(v => v._id),
        filter: filter(),
      });
      contextContainer.setCounts(counts);
    },
    /** @function
     * @async
     * @name more
     * @ignore
     * @desc Fetches the next page of thread previews, according to the loaded thread ids and the count. The returned list is appended to the threads in the context
     */
    more: async () => {
      contextContainer.setEnquiriesLoading(true);
      const { threads } = await inboxService.threads.fetch({
        more: true,
        // venueIds: contextContainer.venues.map(v => v._id),
        filter: filter(),
      });
      // console.log({ threads })
      contextContainer.setEnquiriesAvailable(threads.length >= limit);
      contextContainer.setThreads([...contextContainer.threads, ...threads]);
      contextContainer.setEnquiriesLoading(false);
    },
  };
  const fetchInitialModels = async () => {
    middleware.indicators();
    const { venues, networks, users } = await inboxService.venues.fetch();
    // console.log({ users, venues, networks })
    await contextContainer.setActiveUser(users.pop());
    await contextContainer.setVenues(venues);
    await contextContainer.setNetworks(networks);
    contextContainer.setLockedVenues(
      venues.map(v => v.data()).filter(v => v.enquiries.locked),
    );
    inboxService.Emitter.on('venue', () =>
      contextContainer.setLockedVenues(
        venues.map(v => v.data()).filter(v => v.enquiries.locked),
      ),
    );

    const threadId = getThreadIdFromPath();
    // console.log({ threadId })
    if (threadId) {
      if (mongoId(threadId)) {
        const thread = await middleware.loadThread(threadId);
        if (thread) {
          const { _id, status } = thread.data();
          // console.log({ statusFilter: contextContainer.statusFilter, status })
          contextContainer.setStatusFilter([
            ...new Set([
              ...(contextContainer.statusFilter || []),
              getInboxStatusFromStatus(status),
            ]),
          ]);
          // setTimeout(() => { console.log({ statusFilter: contextContainer.statusFilter, status }) })
          middleware.threads({ ensureThread: _id });
        } else {
          window.history.replaceState('/inbox', 'Inbox', '/inbox');
          middleware.threads();
        }
      } else {
        middleware.threads();
      }
    } else {
      middleware.threads();
    }
    middleware.leads();
  };
  inboxService.init(async () => {
    inboxService.threads.onNew(threadPreviews => {
      // console.log('New', thread_previews)
      contextContainer.setThreads([
        ...threadPreviews,
        ...contextContainer.threads,
      ]);
    });
    inboxService.leads.onNew(leads => {
      contextContainer.setHostLeads([
        ...leads.filter(l => !l._subjects._value.isOrganiser),
        ...contextContainer.hostLeads,
      ]);
      contextContainer.setOrganiserLeads([
        ...leads.filter(l => l._subjects._value.isOrganiser),
        ...contextContainer.organiserLeads,
      ]);
    });
    fetchInitialModels();
    // middleware.counts()
  }, fetchInitialModels);
  setServiceMethods(middleware);
};

let started = false;
const ServiceContext = () => {
  const {
    activeThread,
    threadLoading,
    setActiveThread,
    setThreadLoading,
    threadsFilter,
    setThreadsFilter,
    searchFilter,
    setActiveUser,
    threadsSort,
  } = useContext(ViewContext);
  const {
    indicators,
    setIndicators,
    venues,
    setVenues,
    setLockedVenues,
    setNetworks,
    threads,
    setThreads,
    organiserLeads,
    setOrganiserLeads,
    allLeads,
    setAllLeads,
    missedLeads,
    setMissedLeads,
    hostLeads,
    setHostLeads,
    setCounts,
    setLeadCounts,
    setEnquiriesLoading,
    setEnquiriesAvailable,
  } = useContext(EnquiryContext);
  contextContainer.indicators = indicators;
  contextContainer.setIndicators = setIndicators;
  contextContainer.activeThread = activeThread;
  contextContainer.setActiveThread = setActiveThread;
  contextContainer.setActiveUser = setActiveUser;
  contextContainer.threadLoading = threadLoading;
  contextContainer.setThreadLoading = setThreadLoading;
  contextContainer.statusFilter = threadsFilter;
  contextContainer.setStatusFilter = setThreadsFilter;
  contextContainer.searchFilter = searchFilter;
  contextContainer.venues = venues;
  contextContainer.setVenues = setVenues;
  contextContainer.setLockedVenues = setLockedVenues;
  contextContainer.setNetworks = setNetworks;
  contextContainer.setThreads = setThreads;
  contextContainer.threads = threads;

  contextContainer.allLeads = allLeads;
  contextContainer.setAllLeads = setAllLeads;
  contextContainer.organiserLeads = organiserLeads;
  contextContainer.setOrganiserLeads = setOrganiserLeads;
  contextContainer.hostLeads = hostLeads;
  contextContainer.setHostLeads = setHostLeads;
  contextContainer.missedLeads = missedLeads;
  contextContainer.setMissedLeads = setMissedLeads;

  contextContainer.setCounts = setCounts;
  contextContainer.setLeadCounts = setLeadCounts;
  contextContainer.setEnquiriesLoading = setEnquiriesLoading;
  contextContainer.setEnquiriesAvailable = setEnquiriesAvailable;
  contextContainer.sortOrder = threadsSort;

  if (!started) {
    start();
    started = true;
  }
  return null;
};
export default ServiceContext;
